<template>
  <div class="breakdown">
    <h3>Awarie</h3>
    <dynamic-content class="desc" :content="breakdownHeader" />
    <div class="columns">
      <div class="column is-offset-2 is-4">
        <h4>Telewizja</h4>
        <div class="breakdown__tv">
          <div
            class="entry"
            v-for="(entry, entryIndex) in breakdown.tv"
            :key="entryIndex"
          >
            <a
              :href="phoneHref(entry.phone)"
              class="button is-rounded is-outlined is-white"
            >
              <icon name="fa-phone-alt" />
              <span>{{ entry.phone }}</span>
            </a>
            <div
              class="entry__hours"
              v-for="(availability, availabilityIndex) in entry.availability"
              :key="availabilityIndex"
            >
              <dynamic-content :content="formatAvailability(availability)" />
            </div>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <h4>Internet</h4>
        <div class="breakdown__internet">
          <div
            class="entry"
            v-for="(entry, entryIndex) in breakdown.internet"
            :key="entryIndex"
          >
            <a
              :href="phoneHref(entry.phone)"
              class="button is-rounded is-outlined is-white"
            >
              <icon name="fa-phone-alt" />
              <span>{{ entry.phone }}</span>
            </a>
            <div
              class="entry__hours"
              v-for="(availability, availabilityIndex) in entry.availability"
              :key="availabilityIndex"
            >
              <dynamic-content :content="formatAvailability(availability)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, DynamicContent } from "%helpers";

export default {
  name: "contact-beakdown",

  components: {
    Icon,
    DynamicContent
  },

  props: {
    breakdownHeader: String,
    breakdown: Object
  },

  methods: {
    phoneHref(phone) {
      return "tel:" + phone.replace(/\D/g, "");
    },

    formatAvailability(availability) {
      return availability.replace(/-/g, "\u2013");
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  color: $white;
  font-size: 1.7rem;
  font-weight: 700;
  text-align: center;
  font-family: $family-sans-serif;
}

h4 {
  color: $white;
  font-size: 1.4rem;
  font-weight: 700;
  text-align: center;
  font-family: $family-sans-serif;
}

.breakdown {
  text-align: center;
  color: $white;

  .desc {
    margin: 1rem 1rem 5rem;
  }

  h4 {
    margin-bottom: 2rem;
  }

  .button {
    width: 12rem;
    margin: 0.5rem;
  }

  .entry {
    &__hours {
      margin-top: 0.5rem;
    }

    &:not(:last-child)::after {
      content: "";
      margin: 2rem auto;
      display: block;
      width: 2rem;
      height: 1px;
      border-bottom: solid 1px $white;
    }
  }
}
</style>
